import { useEffect, useState } from 'react';
import { useMFAStore } from '../stores/mfaStore';

export function useMFARequired() {
  const [checking, setChecking] = useState(true);
  const { listFactors, totpFactor, isMfaVerified } = useMFAStore();

  useEffect(() => {
    const check = async () => {
      try {
        await listFactors();
      } catch (err) {
        console.error(err);
      } finally {
        setChecking(false);
      }
    };

    if (!isMfaVerified) check();
    else setChecking(false);
  }, [isMfaVerified, listFactors]);

  return {
    requireMFA: !!totpFactor && !isMfaVerified,
    checking,
  };
}
